import VehicleImportedHistoryHtml from './vehicle.imported-history.html';

export function VehicleImportedHistoryDirective () : ng.IDirective {
  const directive : ng.IDirective = {
    controller: 'VehicleImportedHistoryCtrl',
    restrict: 'E',
    templateUrl: VehicleImportedHistoryHtml,
    scope: {
      vehicle: '=',
      invoices: '='
    }
  };

  return directive;
};
